module.exports = __webpack_public_path__ + "img/royal-am-logo-icon.9e502371.png";